import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import slugify from "../utils/slugify";

const ProductListing = ({ products }) => {
    return (
        <section className="section product-highlight-section">
            <Container>

                {/* Section Heading */}
                <div className="section-title fade-up">
                    <h2>All Products</h2>
                    <p>
                        Explore our complete range of crop protection, plant nutrition,
                        and growth enhancement solutions.
                    </p>
                </div>

                <Row>
                    {products.length > 0 ? (
                        products.map((product) => (
                            <Col
                                lg={3}
                                md={4}
                                sm={6}
                                className="mb-4"
                                key={product.id}
                            >
                                <div className="product-card">

                                    {/* Image */}
                                    <div className="product-image">
                                        <img
                                            src={product.image}
                                            alt={product.productName}
                                        />
                                    </div>

                                    {/* Content */}
                                    <div className="product-content">
                                        <span className="product-category">
                                            {product.category}
                                        </span>
                                        <h4>{product.productName}</h4>
                                        <p>{product.technicalName}</p>
                                    </div>

                                    {/* Hover Overlay */}
                                    <div className="product-overlay">
                                        <h4>{product.productName}</h4>

                                        <Link
                                            to={`/product/${slugify(product.productName)}`}
                                            className="product-btn"
                                        >
                                            View Details
                                        </Link>
                                    </div>

                                </div>
                            </Col>
                        ))
                    ) : (
                        <Col>
                            <p className="text-center text-light">
                                No products found matching your search.
                            </p>
                        </Col>
                    )}
                </Row>

            </Container>
        </section>
    );
};

export default ProductListing;
